var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book"},[_c('BookCoverDetails',{attrs:{"book":_vm.book}}),_c('BookChapters',{attrs:{"book":_vm.book}}),_c('CourseGroupBox',{staticClass:"container",attrs:{"type":"book"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }